import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const sxStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '1000px',
        margin: '0 auto',
        paddingLeft: 5,
        paddingRight: 5,
    },
    head: {
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: 3,
    },
    title: {
        fontSize: '24px',
        marginBottom: 1,
    },
    brand: {
        color: '#4182DC',
    },
    subtitle: {
        fontSize: '18px',
    },
    item: {
        backgroundColor: '#fff',
        borderRadius: '4px',
        padding: 2,
        width: '100%',
        textAlign: 'center',
        minWidth: '200px',
    },
};

const WelcomeSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={sxStyles.root}>
            <Box sx={sxStyles.head}>
                <Box sx={sxStyles.title}>
                    Hi, I am{' '}
                    <Box component="span" sx={sxStyles.brand}>
                        Ecopilot
                    </Box>
                </Box>

                <Box sx={sxStyles.subtitle}>your intelligent emission factor search</Box>
            </Box>

            <Stack
                spacing={2}
                direction={isMobile ? 'column' : 'row'}
                justifyContent="center"
                flexWrap={isMobile ? 'wrap' : 'nowrap'}
                sx={{ marginBottom: 7, width: '100%' }}
            >
                <Box sx={sxStyles.item}>
                    ⚡️ I am <b>fast</b> as lightning
                </Box>
                <Box sx={sxStyles.item}>
                    🌎 I can <b>recognize</b> any language
                </Box>
                <Box sx={sxStyles.item}>
                    🧠 I am <b>smart</b> - challenge me!
                </Box>
            </Stack>
        </Box>
    );
};

export default WelcomeSection;
